<template>
  <div class="privacy-policy">
    <div class="title">
      <h1>{{title}}</h1>
    </div>
    <div class="support-main clearfix">
      <div class="sidebar-column fl">
        <ul>
          <li
            v-for="(item,index) in siderList"
            :key="index"
            @click="clickSidebar(index)"
            :class="index==activeItem?'current':''"
          >
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      <!-- 隐私政策 -->
      <div class="content-column fr">
        <div class="article-typography">
          <div class="content" v-if="activeItem==0">
            <p>请您访问和使用Onitsuka Tiger 网站（简称“本网站”）前仔细阅读以下“使用条款和条件”（简称“条款和条件”）。本网站的所有访问者和用户，不论基于何种目的访问和使用本网站，均视为同意在访问和使用本网站的过程中遵循以下条款和条件及其他应当适用的法律和政策。若您不同意这些条款和条件，请勿访问和使用本网站。</p>
            <h3>网站内容</h3>
            <p>所有在本网站展示的内容（包括但不限于所有文字、图片、音频、视频、应用程序等），及其版权（著作权）、商标权、品牌标识、设计权、专利权和其他任何性质的知识产权（包括已注册和未注册）（以下统称“该等内容”），均属ASICS及/或其他第三方权利人（包括ASICS自其获得授权的相关权利人和ASCIS授权的相关权利人）所拥有。除非经ASICS及/或其他第三方权利人事先的明确的书面许可，任何人不得在访问和使用本网站目的之外，将该等内容作任何方式的校正、复制、再版、张贴、播放、售卖、传输、向公众提供，或以其他任何方式使用该等内容。</p>
            <p>基于相关法律和政策所规定的“为个人使用为目的的复制”及“引用”的场合，可以在合理范围内予以“复制”及“引用”该等内容，但此时必须注明引用该等内容的出处。禁止以该等内容作商业用途。</p>
            <p>条款和条件中的任何内容，均不得被解释为ASICS及/或其他权利人授予本网站的访问和使用者任何许可或有权使用任何版权（著作权）、商标权、品牌标志、设计权、专利权或、ASICS及/或任何其他第三方权利人所拥有的其他任何性质的知识产权。</p>
            <h3>免责申明</h3>
            <p>您须明白，本网站的服务仅依其当前所呈现的状况提供，本网站的服务涉及到互联网等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、互联网络、通信线路原因等造成的服务中断或不能满足您要求的风险。</p>
            <p>本网站相关信息的准确性和完整性，可能因网页的素材、设计、制作、排版或翻译等各种因素而与实际情况有所差异。由于更新频率的关系，本网站介绍的产品及服务内容等信息也可能已经发生了变化，对该等信息进行变更时，ASICS恕不另行通知。ASICS、其附属公司或彼等各自的雇员或授权代理提供的口头或书面建议或信息都不构成任何担保，ASICS不承担所有的相应赔偿。此外，您须承担访问本网站和使用本网站内容的所有风险。在任何情况下，ASICS没有责任为您提供任何支持、或对本网站内容进行修改、更新、升级。</p>
            <p>
              基于相关法律和政策所规定，某些情况不允许排除某些担保，或不允许限制或排除承担对某些损害的责任。因此，以上免责声明和责任限制中的部分内容可能不适用于您。
              <br />
            </p>
            <p>
              <span></span>
            </p>
          </div>
          <div class="content" v-if="activeItem==1">
            <p>生效：2023年9月1日<br /></p>
            <p>您将个人资料分享给我们是对我们的信任，我们珍惜您的信任。ASICS严肃对待您的隐私并致力于以公平和值得信任的方式处理您的个人资料。ASICS将采取全部合理的步骤以保护您的信息不被滥用并安全地保管之。</p>
            <p>我们认为告知您我们将以何种方式使用您的个人资料具有重要意义。因此，我们希望您认真地阅读本隐私政策（以下简称“本政策”），本政策说明我们的隐私保护惯例以及您就个人资料所拥有的相关权利和选择。此外，我们希望在您使用某类服务或购买某类产品时阅读可能存在的其他隐私条款。</p>
            <h3>范围</h3>
            <p>本政策适用于在以下情形中我们收集、使用、披露或以其他方式处理的您的一切个人资料：</p>
            <p>当您创建OneASICS账户或其他ASICS账户；当您访问或使用ASICS网站、应用程序、网店、平台、ASICS的在线、移动端、店铺或其他服务；当您（或您所代表的公司）使用我们的数字服务（如 ASICS Move或 ASICS Runkeeper），在线或通过经销商购买我们ASICS店铺的产品；当您参加ASICS的活动、跑步赛事、促销、竞赛、测试或者研究项目；或当您通过社交媒体或以其他方式线上或线下与我们互动（以下统称“<b>服务</b>”）。</p>
            <p>本政策中的“个人资料”指有关、描述或与您合理关联或类似的任何信息或我们可借此识别您的任何信息，此类信息在以下“我们收集的个人资料”一节中进一步描述。</p>
            <h3>关于我们</h3>
            <p>ASICS是一家国际运动用品公司，总部在日本且机构遍布全球。我们的名称是拉丁文<i>Anima Sana In Corpore Sano</i>（健全精神寓于强健体魄）的缩略语。ASICS创设的理念是：运动是建设健全身心的最佳途径。我们旗下包括：ASICS、Onitsuka Tiger、UNOHA、ASICS Move和ASICS Runkeeper.</p>
            <p>根据您的居住地以及您购买的产品或使用的服务，我们旗下一个或多个ASICS公司将负责管控我们收集的个人资料。请<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">点击此处</a>查看负责处理您个人资料的ASICS公司及其代表概况。负责处理的ASICS公司以下称<b>“ASICS”</b> 或 <b>“我们”</b>。</p>
            <h3>我们收集的个人资料</h3>
            <p>我们收集您的个人数据：(i) 直接收集（例如，当您购买我们的产品、使用我们的服务或以其他方式与我们互动时），包括自动收集（例如，当您访问和使用我们的网站和服务时，请参见 “我们自动收集的个人资料”章节）；(ii) 从第三方间接收集。根据具体情况，上述个人数据可能包括以下内容：</p>
            <h4>概述：</h4>
            <ul>
              <li><i>您的（公司）联系方式。</i>您的姓名和联系方式，比如您的手机号码和电子邮箱地址。</li>
              <li><i>您在我们店铺和线上的购买记录。</i>我们在您使用我们服务购买产品或在店铺购物时收集的数据，比如购买金额和日期、购买的产品或使用的服务、您的衣服或鞋子尺码、与您购物相关ASICS店铺的位置、您的位置、您购买时使用的网站或应用、支付方式、支付状态、折扣、礼品卡或券码、您的账单、订单（物流跟踪）编号、送货方式、送货地址和账单地址以及适用情况下的退货信息。</li>
              <li><i>您的账户数据（包括增加的数据）。</i>您的OneASICS或其他ASICS账户相关数据，比如您的账户名或类似账户唯一标识符、密码、您的出生日期、您的性别或性别认同、语言偏好、居住的国家、您的照片以及其他可能与我们分享的信息。如果您选择通过第三方社交媒体账户（比如Facebook账户）创建OneASICS账户，则ASICS会收到通过相关社交媒体账户保留的基本信息，比如您的电子邮箱地址。如果您选择将您的Race Roster账户与OneASICS账户关联，则ASICS会收到您的Race Roster账户相关信息，比如您的姓名、电子邮箱地址和赛跑注册或赛跑结果相关信息。</li>
              <li><i>您的在线服务使用相关信息。</i>这可能包括您在我们网站上所访问页面的相关数据、您喜欢的产品和服务、您的愿望清单、您废弃购物车的内容以及您浏览过的产品。</li>
              <li><i>关于您子女的详细信息。</i>我们通过您接收的关于您子女的服务数据，比如，他们的姓名或昵称、年龄、性别、鞋码、运动偏好、最喜欢的颜色或图片。</li>
              <li><i>您的休闲活动、兴趣爱好、最喜欢的产品、跑步赛事和其他活动。</i>这包括我们组织或赞助的跑步赛事和活动相关信息，包括您对这些跑步赛事或其他活动的兴趣和注册信息（包括跑步赛事或其他活动的日期、名称、地点、比赛距离以及您的个人目标和结果）、以及您参加跑步和其它健身活动的原因、您喜欢一个人跑步还是喜欢和朋友一起跑步以及您喜欢的其它运动。如果您使用 ASICS Move，根据服务的不同，我们还可能处理其他信息，如比赛号码和您的参赛者 ID。</li>
              <li><i>您的训练情况和运动能力。</i>在我们为您提供赞助时或在您作为训练员、教练、选手或促销员参加活动或促销时您向我们提供的任何信息，包括您的兴趣爱好、技能、资历或成就。</li>
              <li><i>您的训练和跑步数据。</i>您向我们提供的的或通过使用我们服务（比如ASICS Runkeeper）生成的或您从我们的合作伙伴或第三方的其它应用或服务导入的训练和跑步数据，包括您的跑步经验和目前的跑步能力（您能跑的距离以及该距离您能跑进的时间）、您的训练目标（目标距离和跑步赛事时间）、您的表现（距离和跑步赛事时间记录）、您的训练时间表（日期、持续时间和类型）、您的跑步类型（越野跑、正常跑或快跑）以及您的健身活动。</li>
              <li><i>您的（电话）联系人。</i>您与您的联系人为使用我们提供的部分服务（比如ASICS Runkeeper）实现交流而自愿提供访问的数据。ASICS将在征得您同意的情况下，访问并储存您的电话联系人相关信息，从而发现潜在联系并帮助您通过您的Runkeeper信息流（比如评论或链接活动以及添加活动标签）与他们建立联系以及进行交流</li>
              <li><i>您的竞赛和抽奖详情。</i>您参与竞赛、有奖促销或抽奖时我们收集到的数据。</li>
              <li><i>您的评论和内容。</i>您在我们网站或服务上发表的或通过社交媒体或以其他方式在线与我们分享的意见、体验、推荐、偏好、兴趣以及产品或活动的评论，包括您的社交媒体用户名或其他标识符，装备相关经验和技巧、您的比赛日期和训练计划。</li>
              <li><i>您的图像信息和录像。</i>我们店铺和办公室有闭路电视摄像机，当你来访时会记录您的图像信息。我们可能还会在ASICS（赞助的）活动或在其他特定互动期间摄像或拍照。在与我们的服务互动时，您也可以自发向 ASICS 提交照片。</li>
              <li><i>您的通信数据，包括电话记录。</i>当您联系我们寻求支持或其他客户服务请求时，包含通过电子邮件、聊天、在线、电话或者通过社交媒体与您沟通时，我们将保留您的请求记录、您可能提出的任何投诉以及我们收到的任何其他数据。在遵守当地法律的前提下，我们可能会记录和保留此类通信的副本，并保留您的通话记录。</li>
            </ul>
            <br />
            <p>个人资料的特殊分类：</p>
            <p>我们还会收集您自愿向我们提供的与您体格、状况或营养有关的信息，以便在您购买我们的产品和使用我们的服务时进行推荐，并个性化和提升您的购物体验。此类个人资料本身或相结合后可能会显示您的（身体）健康状况。个人资料的特殊分类包括：</p>
            <ul>
              <li><i>活动数据以及您在使用服务时提供的其它信息，包括参与我们的某一测试或研究项目。</i>您的鞋码和衣服尺码以及您自愿与我们分享的，通过使用服务或通过我们的合作伙伴或第三方的其他应用或服务导入的其它个人测量信息和活动数据，比如体重、身高、心率、消耗的卡路里、步数、营养信息、睡眠活动、其它活动数据（健身活动的类型、持续时间和频率、距离、速度、步幅、步频、步数）及受伤情况。</li>
              <li><i>跑步细节。</i>您当下的跑步鞋、您的跑步类型以及您跑步的水平。</li>
              <li><i>测试与测量结果。</i>您参加我们的某项测试或研究项目或测量计划（比如ASICS足部测量、跑步实验室、腿校正测量、人体成分测量、腿力测试、跑步方式测试、有氧测试和类似测量计划和测试）时我们收集的测量数据。我们在测试过程中收集的测量数据还可能包括心率、血压、血氧量、脂肪团和肌肉团重量和百分比、BMI、BMR、力量与耐力。</li>
            </ul>
            <br />
            <p>此外，根据您使用的服务以及您的许可情况，我们还会收集和使用与您位置相关的信息，比如GPS数据、加速度计、计时器或跑步路线（包括显示您地理位置的精确位置数据）。</p>
            <p>在必要的、符合适用法律要求的情况下，我们只会在征得您事先同意或在您的指示下出于本政策所述用途而收集、使用您自愿与我们分享的健康和位置数据。您可随时拒绝或撤销您的同意，如下文所述（见“您的权利”一节）。</p>
            <h4>我们自动收集的个人资料</h4>
            <p>根据当地法律要求，我们还可能收集您的电子识别数据（通过cookies、网络信标或类似技术获取），包括与您访问、使用我们的服务以及与服务交互过程相关的个人资料。这可能包括IP地址、MAC地址、移动设备标识符（IDFA或GAID）、cookie ID、cookie内容、浏览器类型、浏览和点击行为及其他活动、购买信息、域名、来源地址-URL、访问日期和时间、硬件和软件信息以及配置、所使用的设备相关信息（比如设备ID、设备类型）、操作系统、语言以及大概位置。我们还可能通过HTML电子邮件中的像素了解您是否已阅读我们向您发送的信息。更多信息见下方“COOKIES、分析与个性化”一节或我们的<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=3" title="请点击此处" target="_blank" rel="nofollow noopener">Cookie政策</a>。</p>
            <h3>我们如何使用您的个人资料</h3>
            <p>ASICS出于下列用途使用和处理收集到的与您相关的个人资料。</p>
            <ul>
              <li><i>履行我们与您达成的协议。</i>为了管理和处理您在线上、店铺或通过批发进行的购买项目，并向您提供您请求的服务（包括处理您的请求或管理您的ASICS账户），我们使用您的（公司）联系方式、（在我们店铺、线上或通过批发进行的）购买项目相关信息、您的账号和电子识别数据、所使用服务的相关信息、您休闲活动、兴趣爱好和活动的相关信息、您子女的相关信息、您训练或培训能力的相关信息、您训练的相关信息和跑步数据（包括健身活动）、您的竞赛数据、您的通信数据以及在征得您同意后获取的您活动、个人测量的相关信息、您的跑步详情、您的测评结果以及您的位置数据。</li>
              <li><i>遵循法律义务。</i>在上述“我们收集的个人资料”一节提及的任何信息可能用于维持适当的业务记录、遵循公共机关的合法要求以及遵循适用的法律法规或其他法律要求。</li>
              <li><i>合法商业利益。</i>我们在向您有效交付信息、服务和产品的过程中以及在我们有效和合法的业务经营中拥有使用上述“我们收集的个人资料”一节中所提及个人资料的合法权益（在任一情况下，前提是您的权利并未推翻此类利益）。具体而言，我们可使用“我们收集的个人资料”一节中所列相关个人资料用于：
                <ul>
                  <li>营销、促销内容和其他活动：向您发送礼品或优惠券，比如在年底或在您生日时向您发送最新资讯或一般营销资料和促销内容以及您所购买、使用或可能感兴趣产品和服务的相关调研；或通过电子邮件向您发送从购物车中删除的或浏览过的产品。遵循并根据适用法律，ASICS可通过邮政寄件、电子邮件、SMS、其他电子方式或通过其他方式进行营销和促销。您可根据我们通信中的说明随时选择不再接收此类营销资料。您也可以通过个人资料设置或通过联系我们管理您的营销偏好（见“您的权利”）；</li>
                  <li>改善我们的产品和服务：改善我们的产品和服务以及更好地从整体和个体层面了解我们的客户。为此，适用情况下，我们可能从各个曾收集您个人资料的ASICS实体和服务中获取与您相关的数据并将数据合并。这也意味着我们会分析您使用我们产品和服务的情况，并利用此类信息改善我们的产品和服务，为您提供更好的用户体验（如：我们会分析您访问哪些ASICS网页、您 使用和喜欢哪类产品和服务以及您如何使用这些产品和服务，促使我们创建个人档案和评估您的兴趣所在，从而在您购买我们产品或使用我们服务时向您提供个性化建议（比如基于您以往的购买项目及服务使用情况）。我们还能够通过创建此类客户个人档案向您发送与您使用我们的产品和服务相关的个性化营销资料（前提是您选择接收此类资料）；</li>
                  <li>广告：促销我们的产品和服务以及促使我们提供、个性化、评估和改善我们的数字广告。比如，基于您与我们互动的方式或为创建特定目标受众群，向您提供建议和展示定向广告（包括通过第三方网站或社交媒体）。为此，我们可能与我们的广告合作伙伴（包括社交媒体平台，比如Facebook、Instagram、Google、Snapchat、Pinterest等）分享部分个人资料（比如电子识别数据、联系信息、国家和转化状态）。请注意此类信息将不会用于我们广告合作伙伴的自身（营销）用途；</li>
                  <li>个性化内容：进一步个性化定制您的训练计划，使您根据地面情况（比如水泥地、小路或跑步机）对跑步进行调整，或向您提供更详细的跑步相关信息。比如，我们可利用从其他第三方来源获取的数据丰富您的个人资料，如：基于您所在位置的天气预报（预计气温、湿度、风力）和交通预测（空气污染的可能性），从而针对具体跑步提供建议；或在我们的服务中为您提供其他可选的额外服务。例如，如果您使用 ASICS Move，您可以选择使用您的号码布查找比赛期间拍摄的照片；</li>
                  <li>分析和统计数据：生成产品和服务用户以及店铺访客相关的综合统计数据和分析；</li>
                  <li>调研和反馈：获取产品和服务相关反馈，加强和改善我们的产品和服务质量（比如通过进行客户满意度调研或研究）；</li>
                  <li>活动策划和管理：用于活动策划和管理，包括注册、出席、关联您与其他活动参与者来，以及就相关活动和服务与您联系。</li>
                  <li>安全性：安全和防诈和检测；系统完整性（预防黑客、欺诈、垃圾邮件等）；预防、检测和调查诈骗、滥用、骚扰或其他类型的非法活动以及就非法活动、疑似诈骗、涉及威胁任何人士或第三方安全或合法权利的情况、违反本政策和我们适用协议和使用条款采取相关行动。</li>
                  <li>企业经营：促进我们企业经营以及实施公司政策和规程，促使我们合并、销售、收购或转让财产（包括协商上述事项）；以及</li>
                  <li>其他用途：适用法律允许的其他合法经营用途。</li>
                </ul>
                <br />
                <p>鉴于我们以自身合法权益作为法律依据使用您的个人资料，您有权反对此类使用，并且一经反对我们必须停止此类信息处理，除非我们能够证明优先于您利益、权利和自由的资料使用具有强制性合法理由，或者我们需要处理数据以建立、行使或捍卫法律主张（见“您的权利”）。</p>
              </li>
              <li><i>经您同意后使用信息。</i>在您同意的情况下，根据您的同意
                <ul>
                  <li>我们可能将上文“个人资料的特殊分类”一节中提到的个人资料（即健康数据和位置数据）用于本政策中规定的目的。</li>
                  <li>我们可能将上文“我们收集的个人资料”一节中提到的个人资料在当地法律要求同意的情况下用于营销目的，根据您线上个人资料的设置，通过电子邮件、短信、应用程序、推送通知、其他电子方式或其他方式进行；用于以质量和管理目的为客服电话录音；提供与您在 Runkeeper 上的电话联系人联系和互动的机会；与 Race Roster 共享（有限的）个人资料；与其他 Runkeeper 用户共享您的 Runkeeper 活动数据；发送我们的时事通讯；在您同意的前提下参与我们的某些研究项目。 Runkeeper 上的电话联系人联系和互动的机会；与 Race Roster 共享（有限的）个人资料；与其他 Runkeeper 用户共享您的 Runkeeper 活动数据；发送我们的时事通讯；在您同意的前提下参与我们的某些研究项目。</li>
                  <li>我们还可能要求您同意为其他特定目的处理某些个人资料。这种情况下，我们将向您提供我们希望处理的个人资料的完整详细信息以及此类使用的原因，以便您能仔细考虑是否同意。</li>
                </ul>
                <br />
                <p>您可以随时撤销您的同意；见下文“您的权利”一节。</p>
              </li>
            </ul>
            <br />
            <h3>我们如何分享您的资料</h3>
            <p>我们可能会与下述各方分享您的个人资料：</p>
            <ul>
              <li><i>ASICS集团内部的数据控制员。</i>您的个人资料将由可按本政策所述使用您的个人资料的当地ASICS公司进行分享。关于当地ASICS公司的概述，请<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">点击此处。</a>。</li>
              <li><i>服务提供商和处理商。</i>第三方供应商、代理、服务提供商和关联实体与我们密切合作，代表我们提供服务如：支持网站、网店的内部操作（包括我们用来向您的家庭地址发送订单的服务提供商和第三方）、服务（如：技术支持处理）、研究、数字营销以及相关的线下产品支持服务、数据存储和其它服务。</li>
              <li><i>合作伙伴。</i>有时，ASICS 可能会与合作伙伴或联合赞助商合作向您提供服务或应用程序，或允许您使用 OneASICS 账户连接此类服务。在这种情况下，我们也可能会向相关合作伙伴披露您的个人数据，但仅限于您同意或指示我们这样做的情况下，或为完成您的订单或响应您的请求而必须这样做的情况下。我们将在共享之前通知您，您可以选择不参与或以其他方式拒绝此类共享。如果您在竞赛或抽奖中获胜，我们可能会在网上披露获胜者的姓名。 如果您赢得竞赛或抽奖，我们可能会在线披露获奖者的姓名。</li>
              <li><i>Race Roster。</i>如果您选择将您的 OneASICS 账户与 Race Roster 账户关联，Race Roster将与ASICS共享您的特定个人数据（如您的姓名、电子邮件地址以及与您的比赛注册或比赛成绩相关的信息）。同时ASICS 将向Race Roster 共享您的特定个人数据（包括您的 Runkeeper 数据，如您的跑步活动数据）Race Roster将根据其适用的<a href="https://raceroster.com/legal/privacy-policy" title="请点击此处" target="_blank" rel="nofollow noopener">隐私政策</a>进行处理信息。</li>
              <li><i>广告或营销合作伙伴。</i>我们可能与广告合作伙伴（包括 Facebook、Instagram、Google、Snapchat、Pinterest 等社交媒体平台）共享部分个人资料（例如电子识别数据、联系信息、国家和转换状态），基于您与我们互动的方式或为创建特定目标受众群向您展示建议和定向广告（ 也在第三方网站或社交媒体上）。</li>
              <li><i>Runkeeper 用户。</i>如果您同意，我们也可能与其他 Runkeeper 用户（联系人或（推荐的）朋友）分享您的训练和跑步数据。</li>
              <li><i>ASICS Move用户。</i>当您在 ASICS Move上注册或捐赠一项赛事或活动时，我们将与赛事或活动的组织者和相关方共享必要的个人数据。“相关方”可能包括与应用程序上主办的赛事有关的慈善或非营利组织，以及其他指定的服务提供商，如赛事管理员和计时员。相关方应根据各自的隐私政策处理您的个人数据。</li>
              <li><i>法律要求的第三方。</i>我们可能也会披露您的个人资料，只要我们认为法律要求我们这样做，或这样做是遵循法律程序合理所需的；我们认为向执法当局披露个人资料是有必要的或适当的，这样才能调查是否有实际或疑似欺诈或违法行为、是否有违反安全规定或违反本隐私政策的行为；对针对我们提出的索赔作出回应；保护ASICS、我们的客户或公众的权利、财产和个人安全。</li>
              <li><i>公司交易。</i>在法律允许的情况下，我们可能披露个人信息，作为任何实际或拟定的合并、销售、转让ASICS资产和收购、破产或类似事件的一部分，包括在此类事件之前进行的尽职调查的相关数据。</li>
              <li><i>征得同意。</i>我们可能也会向其他第三方披露关于您的信息（包括个人资料），前提是，您同意或要求我们这样做。</li>
            </ul>
            <br />
            <p>尽管本隐私政策有其它条款，我们也可能会出于研究、营销、分析和其他目收集、使用以及与第三方分享汇总的或去标识化的信息，前提是此类信息不会识别特定个人。在使用、披露或处理去标识化信息时，我们将以去标识化的形式维护和使用这些信息，除非另有适用的法律，否则我们不会试图重新识别这些信息。</p>
            <h3>Cookies、分析与个性化</h3>
            <p>经您事先同意（在要求的范围内），我们的第三方提供商和我们都会使用cookies、清晰的GIFs/像素标签、JavaScript、局部存储器、日志文件和其它机制来自动收集和记录与您的浏览活动及服务使用情况有关的信息。我们可能将此类“活动信息”与我们收集的关于您的其它个人资料相结合。</p>
            <p>一般情况下，我们会利用此类活动信息了解我们的服务被如何使用、追踪漏洞和错误、改善我们的服务、核实账户认证信息、允许登陆、追踪会议、预防欺骗和保护我们的服务以及用于目标营销与广告目的、使内容个性化并作为分析之用。关于这些机制及我们如何收集并使用活动信息的更多详细信息，见我们的<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=3" title="请点击此处" target="_blank" rel="nofollow noopener">Cookie政策</a>。</p>
            <ul>
              <li><i>禁止追踪。</i>请注意，我们不会对浏览器的“禁止追踪”要求作出回应。不过，您可以禁用特定的 Cookies，详情请参见我们的<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=3" title="请点击此处" target="_blank" rel="nofollow noopener">Cookie政策</a></li>
            </ul>
            <br />
            <h3>社交媒体</h3>
            <p>我们的服务可能包含第三方社交网站的链接和插件，以促进社交媒体功能，这些网站和插件可能会收集有关您的个人数据。如果您点击链接，这些第三方可能会收集有关您的信息，并可能在您每次访问其各自网站或服务时自动记录有关您浏览行为的信息。 当您参与各种社交媒体论坛时，如：Facebook、X、Snapchat、Yammer、Pinterest、Instagram、LinkedIn等，您应该熟悉并了解这些网站提供的、让您可以选择如何分享您的社交媒体档案中的个人资料的工具和服务。</p>
            <p>请注意，相关的隐私惯例和第三方政策（非本政策）适用于这些工具对数据的处理，因此，我们鼓励您阅读适用的隐私通知、使用条款以及有关您的个人资料如何用于上述社交媒体环境的相关信息。</p>
            <p>此外，视您在各种社交媒体网站上的设置（或结合您在ASICS页面上的设置）作出的选择而定，可与ASICS分享您的在线活动和社交媒体档案的某些个人资料（如：爱好、婚姻状况、性别、用户名、相片、评论及您发布/分享的内容等）。</p>
            <h3>如果您未满16岁</h3>
            <p>我们的在线服务和应用并不针对（13）十三岁以下的儿童，我们不会有意直接收集（13）十三岁以下儿童的个人数据。如果您认为我们在没有法律依据的情况下收集了关于（13）十三岁以下儿童的信息，请联系我们（参见以下的“数据保护专员——联系方式与咨询”章节），以便我们能采取适当的步骤删除该等信息。</p>
            <p>如果您已年满13岁但未满16岁，您必须在向我们提供您自己的个人资料之前先取得您父母或合法监护人的同意。您的父母或监护人应联系负责使用您的个人资料的ASICS公司（关于当地ASICS公司的概述，请<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">点击此处</a>），并向我们提供他们的姓名、电子邮箱以及我们可能要求的任何其他身份信息。ASICS需要用这些信息核实他们是否给予了必要的同意。有些情形下我们可能通过电话或以其他方式跟进。如果您已年满13岁但未满16岁，在您的父母或监护人未向我们发电子邮件同意您与我们联系并提供任何个人资料以前，请不要与我们联系或者向我们提供任何该等信息。</p>
            <h3>您的个人资料的国际传输</h3>
            <p>请知悉：我们会把您提供给我们的任何个人资料转移到您的居住国/地区以外的国家/地区。该等国家/地区的法律可能无法对您的个人资料提供与您所在的国家/地区相同水平的保护。因此，ASICS将争取确保全部充分的保障措施已到位而且该传输遵守全部适用的法律法规。</p>
            <p>对于从欧洲经济区（“EEA” ）或英国传输到 EEA/英国以外的未提供足够保护水平的国家或地区的数据，ASICS 目前使用基于欧盟标准合同条款（“标准合同条款”）的集团内部数据传输协议和其他当地法律转让条款。对于从 EEA 和英国向 ASICS 集团公司以外各方的传输，ASICS 将基于适当的保障措施进行传输，例如标准合同条款或其他获批的数据传输或认证机制，以及接收方的具有约束力和可执行的承诺。每一次，ASICS 都会评估传输并确保采取任何额外的技术和组织措施，以确保提供足够的保护水平。</p>
            <h3>安全</h3>
            <p>ASICS已采取技术、物质和组织措施和控制措施，保护我们所收集您的个人资料不会受到未经授权或不合法的使用和变更、未经授权访问或披露、意外或非法销毁以及丢失。请注意，尽管我们做出了努力，但没有任何安全措施可以保证绝对安全。此外，您还可以采取某些措施来保护您的账户和您的个人资料，例如，不要在多个网站上重复使用密码，选择不易被猜到的密码，以及及时报告任何可疑活动或未经授权的账户访问。</p>
            <h3>数据保存</h3>
            <p>ASICS会保存您的个人资料直到实现收集和使用此等资料的目的（例如，及时为您发送您所订阅的最新资讯，为您提供相应的客户服务、解答您的疑问或者解决技术问题等），除非更长的时间对于履行我们的法律义务或防卫一项法律申诉是必须的。</p>
            <p>如果您已经创建了一个OneASICS账户或者其他的ASICS账户，我们将基于您的请求或者在账户闲置（30）三十天内将该账户和您的个人资料删除。如果您在（2）两年内未曾使用过您的OneASICS账户或其他ASICS账户，我们会认为您的账户是“闲置”的。在您的账户被认定为“闲置”之前，我们会通知您使用您的OneASICS账户或其他ASICS账户，防止您的账户闲置。当我们清除您的账户时，您的个人资料会被删除，除非您使用Runkeeper 应用，在这种情况下，您的训练和跑步数据将在您的账户闲置后额外存储 4 年（除非您要求我们尽早删除您的资料）。此外，如有必要遵守我们的法律要求，或有必要建立、行使或捍卫我们的法律权利（包括回应实际或潜在的法律索赔），我们可能会将您的某些个人数据保留更长时间。</p>
            <h3>您的权利</h3>
            <p>根据适用法律，您就个人资料享有以下权利：获取权、整改权、清除权、限制数据处理权、反对建档权及资料可携权。如果您想行使以上权利中的任何一项，则请联系负责使用您个人资料的 ASICS 公司。可在<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">此处</a>找到所有联系方式的概览。</p>
            <p>我们基于自己的合法权益在一定程度来使用您的个人资料，您也拥有反对该等使用的权利（除非我们可以证明该等使用的强制性合法理由优先于您的利益、权利和自由或我们需要该等使用以建立、实行、防卫我们的法律申诉）。</p>
            <p>我们将根据适用的法律回应您的隐私权请求。 为了保护您和他人，我们可能（取决于请求的类型）需要在处理您的请求之前验证您的请求和身份。</p>
            <p>您可以按照营销沟通指示随时免费撤回您接收营销沟通的同意。您也可以在您的档案中控制该等选择权。</p>
            <p>如果您希望撤回对ASICS使用您的健康数据或定位数据的同意，您可以向负责使用您的个人资料的ASICS公司（概述见<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">此处</a>）发送电子邮件。您也可以在您的配置文件和设备中设置该等选择权。</p>
            <p>如果您对我们处理您的个人资料的方式有任何疑问或投诉，您可以向负责使用您的个人资料的ASICS公司（概述见<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">此处</a>）发送电子邮件。或者，您可以考虑向数据保护监督当局提出投诉。</p>
            <p>特定管辖区的附加信息，下文 “地区差异”章节提供了有关特定司法管辖区（如下所列）隐私法规定的个人权利的附加信息。</p>
            <h3>地区差异</h3>
            <p>在下列司法管辖区中，除上述“您的权利”一节中规定的规则和权利外，还适用其他或不同的规则和权利。您可以点击查看您所在的司法管辖区相关的规则</p>
            <ul>
              <li><a href="https://legal.asics.com/jp-jp/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">日本</a></li>
              <li><a href="https://legal.asics.com/en-us/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">美国</a></li>
              <li><a href="https://legal.asics.com/en-ca/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">加拿大</a></li>
              <li><a href="https://legal.asics.com/pt-bz/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">巴西</a></li>
              <li><a href="https://legal.asics.com/en-aop/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">澳大利亚</a></li>
              <li><a href="https://legal.asics.com/en-aop/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">新西兰</a></li>
              <li><a href="https://legal.asics.com/cn-cn/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">中国大陆</a></li>
              <li><a href="https://legal.asics.com/kr-ko-kr/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">韩国</a></li>
              <li><a href="https://legal.asics.com/en-aap-sg/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">新加坡</a></li>
              <li><a href="https://legal.asics.com/th-th/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">泰国</a></li>
              <li><a href="https://legal.asics.com/ms-my/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">马来西亚</a></li>
              <li><a href="https://legal.asics.com/id-id/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">印度尼西亚</a></li>
              <li><a href="https://legal.asics.com/en-sf/legal/local-deviations" title="请点击此处" target="_blank" rel="nofollow noopener">南非</a></li>
            </ul>
            <br />
            <h3>其它网站</h3>
            <p>我们的网站和移动端应用中包含第三方网站的链接；如果您点开该等链接，您将退出我们的网站或移动端应用。尽管在选择该等第三方网站时尽了注意义务，ASICS不就该等组织对您的个人资料的使用承担责任。详细信息请查询您访问的网站的隐私声明（如有）。</p>
            <h3>政策的变更</h3>
            <p>我们以在我们的网站和应用程序上发布更新版本政策的方式不时变更本政策。我们将在我们的网站上就任何重大变更给您合理的告知。如果我们对本政策进行任何修改，从而对我们之前从您那里收集的个人数据的处理方式产生实质性影响，我们将通过在网站上突出显示修改内容或以电子方式通知您的方式，尽力提前向您发出合理通知。我们鼓励您经常访问以持续了解我们将如何使用您的个人资料。</p>
            <h3>数据保护专员——联系方式与咨询</h3>
            <p>如果您对您的个人资料的处理或本政策有任何疑问，请联系ASICS数据保护专员或负责使用个人资料的ASICS公司。关于所有隐私联系方式的概述，请<a href="https://www.onitsukatiger.com/cn/zh-cn/privacy-policy?active=5" title="请点击此处" target="_blank" rel="nofollow noopener">点击此处</a>。</p>
          </div>
          <div class="content" v-if="activeItem==2">
            <p>咨询Onitsuka Tiger官方商城购物及在线订单相关问题，请拨打以下客服热线：</p>
            <p>-中国大陆地区: 021-60663345</p>
            <p>服务时间:</p>
            <p>星期一至日 9:00-22:00</p>
            <p></p>
            <!-- <p>如果您就对您的个人资料的处理以及本隐私政策有任何疑问，请联系您居住地的ASICS公司。联系方式如下：</p>
            <p>
              <span></span>
            </p>
            <p>ASICS China Trading Co., Ltd, 亚瑟士（中国）商贸有限公司</p>
            <p>上海市长宁区娄山关路533号21层08单元。</p>
            <p>联系电话：400-821-0893</p>
            <p>联系方式：请电邮至<a href="mailto:cs.acn@asics.com">cs.acn@asics.com</a>.</p> -->
            <p>微客服：请添加微信公众号OnitsukaTigerChina</p>
            <!-- <p>以上渠道工作时间均为：工作日9：00-18：00</p> -->
            <p>
              <span></span>
            </p>
            <p>
              <a target="_blank" class="udesk-go-service">客服中心</a>
            </p>
            <p>
              <span></span>
            </p>
          </div>
          <div class="content" v-if="activeItem==3">
            <p>
              <strong>生效日期：</strong>
              <strong>2016</strong>
              <strong>年</strong>
              <strong>11</strong>
              <strong>月</strong>
              <strong>1</strong>
              <strong>日</strong>
            </p>
            <p>
              <span></span>
            </p>
            <p>ASICS在其在线服务中使用cookies以及类似技术以提高用户体验并尽可能保持对每一位访客的服务流畅度。该等技术包括：cookies、pixel tags、IP addresses、scripts以及移动端广告识别码。ASICS以及其第三方伙伴（包括计算网络数据以及提供网络媒体广告服务或者盈利性广告服务的伙伴）使用Cookies以及类似技术以满足多重目的。</p>
            <p>
              <span></span>
            </p>
            <p>
              本cookie政策向您提供我们以及我们的第三方伙伴使用的cookies以及类似技术的相关信息、使用它们的目的以及您如何应付该等技术。本政策仅适用于与其有关联的网站和移动端应用，包括： 
              <a href="http://www.asics.com" target="_blank" title="www.asics.com" rel="nofollow">www.asics.com</a>、
              <a href="http://my.asics.com" target="_blank" title="my.asics.com" rel="nofollow">my.asics.com</a>、
              <a href="http://www.asics.com" target="_blank" title="www.asics.com" rel="nofollow">www.asics.com</a>、
              <a href="http://www.onitsukatiger.com" target="_blank" title="www.onitsukatiger.com" rel="nofollow">www.onitsukatiger.com</a>以及MY ASICS移动端应用。 ASICS以及我们的集团内公司所提供的其他在线服务则适用不同的cookie政策。
            </p>
            <p>
              <span></span>
            </p>
            <p>
              关于ASICS如何收集、使用以及分享与服务相关的信息的详细信息，请访问
              <a href="https://legal.asics.com/cn-cn/legal/privacy-policy" target="_blank" title="ASICS隐私政策" rel="nofollow">ASICS隐私政策</a>。
              如果您对本cookie政策有任何疑问，请联系
              <a href="https://legal.asics.com/cn-cn/legal/overview-of-asics-companies" target="_blank" title="联系方式与咨询" rel="nofollow">您所在地的ASICS公司</a>。
            </p>
            <p>
              <span></span>
            </p>
            <h3>服务中使用了哪些cookies和类似技术？</h3>
            <p>我们和我们的第三方伙伴在服务中使用多种cookies和类似技术，包括：</p>
            <p>
              <span></span>
            </p>
            <p>
              <strong>Cookies</strong>
              <strong>。</strong>Cookies是您的网页浏览器在您的电脑上保存的小文件。Cookie使得服务可以辨认您是否曾经访问并能保存用户的偏好以及其他信息。
            </p>
            <p>
              <span></span>
            </p>
            <ul>
              <li>
                <span></span>
                <strong>甲方</strong>
                <strong>cookies</strong>由您所访问的网站所设置。其可以让您浏览网页的体验更高效。例如，其帮助我们记住：
              </li>
              <li>
                <span></span>您的购物车中的物品；
              </li>
              <li>
                <span></span>您的登入名称；以及
              </li>
              <li>
                <span></span>您的偏好，例如您偏好的语言或地点。
              </li>
              <li>
                <span></span>
                <strong>第三方</strong>
                <strong>cookies</strong>由您所浏览的网站以外的其他公司设置。例如，我们可能会与某广告网络形成伙伴关系以推送广告给您。我们也可能与某分析公司形成伙伴关系以帮助我们了解用户是如何与我们的网站互动的。该等“第三方”公司也可能会在您的浏览器上设置cookies以持续了解您的行为。第三方的跟踪机制的使用适用其自身的隐私政策，而非本政策。
              </li>
            </ul>
            <p>
              <span></span>
            </p>
            <p>
              <strong>Pixel tags</strong>
              <strong>。</strong>Pixel tags或网络信标是代表网页或电子邮件上某图形图像请求的一小串软件代码。Pixel tags或网络信标可能有也可能没有相关的可视图形图像，而且该图像通常设计融入网页或电子邮件背景。其可以被嵌入网页或电子邮件以传达信息，可能包括个人信息。Pixel tags可以用于许多目的，包括现场交通信息报导、独立访客计数、广告审计与报告、以及确定某用户是否打开了特定电子邮件。
            </p>
            <p>
              <span></span>
            </p>
            <p>
              <strong>IP</strong>
              <strong>地址。</strong>IP地址（互联网通信协议地址）是某电脑、设备或在线服务的地址。其形式如: 198.101.218.235。它使电脑可以互相辨识并可以确定通过互联网向哪里发送信息。通常是从您使用的网络为您的电脑或其他设备分配一个IP地址，以用于将网站资料发送回您的网络浏览器。您的电话通过Wi-Fi或移动网络连接至互联网时所使用的也是类似流程。您的地址变换时您的电脑或电话的IP地址也可能持续变换。
            </p>
            <p>
              <span></span>
            </p>
            <p>
              <strong>移动端识别码。</strong>我们和我们的第三方伙伴可能使用移动端识别码以收集您在移动端设备上使用服务的相关信息。例如，多数现代移动端设备（iOS 6、Android 2.3、Windows 10及以上版本）均提供移动端广告识别码。它们是随机生成的与您的设备相关的字母数字代码，通常还伴有重置识别码以及不接受盈利性广告的选项。该等识别码视操作系统的不同而名称各异。例如，在Android设备上称为Advertising IDs而在iOS设备上称为Identifiers for Advertisers（IDFA）。可能使用该等技术以及其他移动端设备识别码以监控某特定的设备上移动端应用的使用情况。
            </p>
            <p>
              <span></span>
            </p>
            <h3>ASICS服务如何使用cookies以及类似技术？</h3>
            <p>
              <span></span>
            </p>
            <p>
              <strong>功能性</strong>
              <strong>Cookies</strong>
              <strong>以及类似技术</strong>
            </p>
            <p>
              <span></span>
            </p>
            <p>服务使用cookies以及类似技术以确保我们的网站以及移动端应用正确运行。我们将该等cookies称为“功能性cookies”，我们使用其的目的在于：&nbsp;</p>
            <p>
              <span></span>
            </p>
            <ul>
              <li>保存偏好，如语言、地点、将显示的搜索结果数目、登入信息等；</li>
              <li>记录您加入您的购物车的物品；</li>
              <li>检测对我们的网站和服务的误用，如通过记录数次连续的登入不成功的方式；以及</li>
              <li>将荷载在我们的各服务器间进行分配，以使服务处于可用状态。</li>
            </ul>
            <p>
              <span></span>
            </p>
            <h3>分析</h3>
            <p>为了确定我们服务的用户中哪些人对服务最感兴趣并提高服务的质量，我们使用各种分析跟踪机制对服务进行测量和检验。包括对Google Analytics等各类第三方软件的使用。该等第三方软件可能在您的电脑或其他设备上设置并进入cookies并可能收集与您在服务上活动相关的信息。有关您对我们的网站和移动端应用的使用的信息可能传送至该等第三方并保存在位于美国的服务器上。</p>
            <p>分析在所收集的信息的基础上进行。它使我们可以在服务的结构、导航和内容等方面尽可能人性化。我们使用cookies以及类似技术具体要满足的目的为：</p>
            <ul>
              <li>
                <span></span>记录访问我们的网页的访客数量以及我们的移动端应用的使用情况；
              </li>
              <li>
                <span></span>记录每位用户在我们的网页或者移动端应用专题上所花费的时间；
              </li>
              <li>
                <span></span>确定某访客访问我们的网站或移动端应用的各个网页或专题的顺序；
              </li>
              <li>
                <span></span>评定网站的哪些部分需要变更；以及
              </li>
              <li>
                <span></span>优化该网站或移动端应用。
              </li>
            </ul>
            <p>如何选择不接受Google Analytics，请参见以下“如何选择不接受某些分析以及盈利性广告？”的内容。</p>
            <h3>反馈</h3>
            <p>服务还使用第三方伙伴提供的反馈cookies。该等cookies使您可以与我们分享您的创意、疑问、评级和问题，可以将您的反馈分享给其他人，还可以阅读其他人留下的反馈。该等第三方也可以使用和保存cookies以在各网络服务器间进行荷载分配。</p>
            <p>
              <span></span>
            </p>
            <h3>社交媒体</h3>
            <p>
              <span></span>
            </p>
            <p>我们的服务可能集成某些第三方插件（如Facebook的“like”键）以及社交媒体专题。即便您未点击该等插件，该等第三方仍可能收集您的相关信息，例如您的IP地址以及您所浏览的网页。他们也可能设置和/或进入cookie。我们可能允许您使用您的社交媒体账户登入我们的服务。在此情形下，您的社交账户提供方可能与我们分享您的某些信息，例如您的公开资料。该等插件和专题适用其提供方公司的隐私政策。</p>
            <p>
              <span></span>
            </p>
            <h3>在线和盈利性广告</h3>
            <p>
              <span></span>
            </p>
            <p>我们的服务可能会使第三方跟踪机制可以持续地和跨无关联网站和移动端应用地收集资料以用于盈利性广告。例如，第三方因您访问过该网站或者使用过某移动端应用的专题而在非ASICS网站和移动端应用上向您推送ASICS产品的在线广告。 另外，我们的第三方广告伙伴可能使用您使用该服务的相关信息以借助您通常的在线行为确定向您推送的非ASICS广告。选择不接受第三方盈利性广告技术的，请参见以下“如何选择不接受某些分析以及盈利性广告？”的内容。</p>
            <p>第三方也可能将cookies和类似技术用于广告投递和报告之目的，例如依据特定类型的浏览器或者当时的情况提供具体的广告；基于网站或移动端应用上的活动的统计报告；分析与分析报告；优化广告布点；广告绩效；范围和频次度量（如频次上限）；安全与防欺诈；开账单；以及记录在某个特定日期向某个特定的网站或移动端应用发布的广告的数量和种类。</p>
            <p>
              <span></span>
            </p>
            <h3>如何调整我的浏览器设置并删除cookies或移动端识别码？</h3>
            <p>
              <span></span>
            </p>
            <p>如果您不希望网站在您的电脑上存储cookies，您可以变更您的浏览器设置，从而可以在某些cookies被存储前收到预警。您也可以变更您的浏览器设置以让您的浏览器拒绝大部分的cookies或者仅拒绝某些第三方cookies。您也可以删除已存储的cookies。请注意：您需要变更您所使用的每一个浏览器和电脑的设置。而且，该等方法对某些非cookie在线跟踪机制没有作用。</p>
            <p>
              <span></span>
            </p>
            <p>请知悉：如果您不希望接受任何cookies，我们将无法保证我们的网站正确运作。某些功能可能不可用或者该网站的某些部分可能无法浏览。</p>
            <p>
              <span></span>
            </p>
            <p>变更您的设置和cookies的程序视浏览器的不同而各异。如有必要，请使用您浏览器上的帮助功能或者点击以下链接之一直接进入您浏览器的使用手册。</p>
            <p>
              <span></span>
            </p>
            <ul>
              <li>
                <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" rel="nofollow">Chrome</a>
              </li>
              <li>
                <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="nofollow">Firefox</a>
              </li>
              <li>
                <a href="http://windows.microsoft.com/en-GB/internet-explorer/delete-manage-cookies#ie=ie-11" target="_blank" rel="nofollow">Internet Explorer</a>
              </li>
              <li>
                <a href="https://support.apple.com/kb/PH21411?viewlocale=en_US&amp;locale=en_US" target="_blank" rel="nofollow">Safari</a>
              </li>
            </ul>
            <p>
              <span></span>
            </p>
            <p>您也可以在您的移动端设备的设备设置中重置广告识别码。iOS用户可访问Settings &gt; Privacy &gt; Advertising &gt; Reset Advertising Identifier。Android用户可访问Google settings &gt; Ads &gt; Reset advertising ID。该等控件的效果与在浏览器中删除cookies的效果很相似——该设备与以往的活动相联系的难度增大，但跟踪仍然可能通过新的广告识别码而发生。</p>
            <p>
              <span></span>
            </p>
            <h3>如何选择不接受某些分析以及盈利性广告？</h3>
            <p>
              <span></span>
            </p>
            <p>
              你可以通过访问
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="nofollow">
                <span></span>
              </a>
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="nofollow">https://tools.google.com/dlpag...</a>选择不接受Google Analytics为分析之目的而使用cookies。
            </p>
            <p>
              <span></span>
            </p>
            <p>您可以按照以下指示选择不接受网页浏览器以及移动端应用中的第三方盈利性广告。请注意：该不接受仅适用于您通过其选择不接受的特定浏览器或设备；因此，您需要分别在您的全部浏览器和设备上均选择不接受。如果您删除或者重置您的cookies或移动端识别码、变更浏览器、或者使用另一个设备，则任何选择不接受的cookie或工具均不再有效，您需要再次选择不接受。</p>
            <p>
              <span></span>
            </p>
            <ul>
              <li>
                <span></span>
                <strong>网页浏览器选择不接受。</strong>在网页浏览器中选择不接受的，请访问Network Advertising Initiative的Consumer Opt-Out页面：
                <a href="http://www.networkadvertising.org/choices" target="_blank" rel="nofollow"><span></span></a>
                <a href="http://www.networkadvertising.org/choices" target="_blank" title="www.networkadvertising.org/cho..." rel="nofollow">www.networkadvertising.org/cho...</a>、Digital Advertising Alliance （DAA）的Consumer Choice页面：
                <a href="http://www.aboutads.info/consumers" target="_blank" rel="nofollow"><span></span></a>
                <a href="http://www.aboutads.info/consumers" target="_blank" title="www.aboutads.info/consumers" rel="nofollow">www.aboutads.info/consumers</a>、 Digital Advertising Alliance of Canada的Consumer Choice页面：
                <a href="http://www.youradchoices.ca/choices" target="_blank" rel="nofollow"><span></span>                </a>
                <a href="http://www.youradchoices.ca/choices" target="_blank" title="www.youradchoices.ca/choices" rel="nofollow">www.youradchoices.ca/choices</a>、以及Digital Advertising Alliance of Australia的Choice 页面：
                <a href="http://www.youronlinechoices.com.au/opt-out/" target="_blank" rel="nofollow"><span></span></a>
                <a href="http://www.youronlinechoices.com.au/opt-out/" target="_blank" rel="nofollow">http://www.youronlinechoices.c...</a>。
              </li>
            </ul>
            <p>
              <span></span>
            </p>
            <p>
              您也可以自
              <a href="http://www.aboutads.info/pmc" target="_blank" rel="nofollow"><span></span></a>
              <a href="http://www.aboutads.info/pmc" target="_blank" title="www.aboutads.info/pmc" rel="nofollow">www.aboutads.info/pmc</a>下载Digital Advertising Alliance的“Protect My Choices”工具以在DAA的Consumer Choice页面上保留您所设置的选择不接受选项。
            </p>
            <p>
              <span></span>
            </p>
            <ul>
              <li>
                <span></span>
                <strong>移动端应用选择不接受。</strong>在移动端应用中选择不接受的，请自
                <a href="http://www.aboutads.info/appchoices" target="_blank" rel="nofollow"><span></span></a>
                <a href="http://www.aboutads.info/appchoices" target="_blank" title="www.aboutads.info/appchoices" rel="nofollow"
                >www.aboutads.info/appchoices</a>下载Digital Advertising Alliance的AppChoices工具并在您的移动端设备上调整广告选项。在iOS系统中调整广告选项的，请访问Settings &gt; Privacy &gt; Advertising &gt; Limit Ad Tracking。在Android系统中调整广告选项的，请访问Settings &gt; Google &gt; Ads &gt; Opt out of interest-based ads。
              </li>
            </ul>
            <p>
              <span></span>
            </p>
            <p>请注意：我们的服务目前对Do Not Track浏览器信号没有响应。</p>
            <p>
              <span></span>
            </p>
            <h3>本政策的变更</h3>
            <p>
              <span></span>
            </p>
            <p>我们可以通过在我们的服务上发布政策更新版本的方式不时变更本cookie政策。任何变更均将在本政策文首所发布的“生效”日期生效。我们鼓励您经常访问以持续了解我们将如何使用cookies以及类似技术。</p>
          </div>
          <div class="content" v-if="activeItem==4">
            <p>1949年，创始人鬼塚喜八郎先生在日本神户的家中，设计出了第一款Onitsuka Tiger鞋款。</p>
            <p>Onitsuka Tiger鬼塚虎株式会社（现更名ASICS集团）创立于1949年，起源于鬼塚喜八郎期望透过运动增进青少年健康的使命。从此，Onitsuka Tiger线条便等同于高质感的象征。</p>
            <p>如今成为传奇性运动时尚品牌，完美融合日式传统与摩登天赋，设计涵括进化的经典鞋型、全新款式及与艺术家、文化鉴赏家的合作联名，在Onitsuka Tiger各鞋款、服饰和配件中皆可感受日本文化的共鸣。</p>
          </div>
          <div class="content" v-if="activeItem==5">
            <h3>负责使用个人资料的ASICS公司概述</h3>
            <p>视您使用的服务、您购买的产品及您居住的地方而定，以下特定国家/地区的ASICS公司负责使用您的个人资料。</p>
            <p>
              如您需要获取以下ASICS公司的联系方式，请
              <a href="https://www.asics.com/privacy/?_ga=2.114380677.326370052.1648616987-1339694605.1627613233" title="请点击此处" target="_blank" rel="nofollow noopener">点击此处</a>：
            </p>
            <p><strong>全球</strong></p>
            <p><strong><u>ASICS RUNKEEPER , ASICS STUDIO和ASICS MOVE</u></strong></p>
            <p>当您在ASICS Runkeeper应用程序，ASICS Studio 应用程序或ASICS MOVE 使用/购买以下服务和产品时，ASICS Runner App, Inc.将被视为负责收集和使用您的个人数据。</p>
            <p>ASICS Runner App, Inc. 的联系方式：</p>
            <dl>
              <dd>ASICS Runner App, Inc.</dd>
              <dd>125 Summer St., Fl. 2, Boston,</dd>
              <dd>MA 02111 U.S.A.</dd>
            </dl>
            <br />
            <p>对于欧盟的居民，ASICS欧洲有限公司将担任第27条“ASICS Runner App, Inc.的通用数据保护条例”定义的代表。对于英国居民，ASICS 英国有限公司将担任第27条“ASICS Runner App, Inc.的通用数据保护条例”定义的代表。 关于联系方式（及数据保护专员的联系方式），详见下文。</p>
            <p><strong><u>总部提供的全球性服务</u></strong></p>
            <p>当您使用ASICS总部提供的某项服务（如ASICS FOOT ID、ASICS STEPNOTE），或参与ASICS总部赞助的全球赛事或活动（如ASICS World Ekiden、ASICS全球抽奖活动），或ASICS人体工学研究所的研究项目时，ASICS总部将负责收集和使用您的个人资料。</p>
            <p>ASICS总部的联系方式是：</p>
            <dl>
              <dd>ASICS Corporation</dd>
              <dd>7-1-1, Minatojima-Nakamachi, Chuo-ku</dd>
              <dd>Kobe 650-8555 Japan</dd>
            </dl>
            <br />
            <p>对于欧盟的居民，ASICS欧洲有限公司将担任第27条“ASICS Runner App, Inc.的通用数据保护条例”定义的代表。对于英国居民，ASICS 英国有限公司将担任第27条“ASICS Runner App, Inc.的通用数据保护条例”定义的代表。 关于联系方式（及数据保护专员的联系方式），详见下文。</p>
            <p><strong><u>日本</u></strong></p>
            <p><strong><u>ASICS 产品和服务</u></strong></p>
            <p>如果您在日本的店铺购买ASICS产品，或使用ASICS日本公司提供的某项服务，ASICS日本公司将被视为负责收集和使用您的个人资料。ASICS日本公司的联系方式是：</p>
            <dl>
              <dd>ASICS Japan Corporation</dd>
              <dd>3-1-18, Shinsuna, Koto-ku</dd>
              <dd>Tokyo 136-8585 Japan</dd>
            </dl>
            <br />
            <p><strong><u>东京湾/大阪吹田ASICS体育中心</u></strong></p>
            <p>当您访问东京湾/大阪吹田ASICS体育中心和/或使用ASICS体育中心应用程序时，ASICS体育中心公司将被负责收集和使用您的个人数据。ASICS体育中心公司的联系方式是：</p>
            <dl>
              <dd>ASICS Sports Complex Corporation</dd>
              <dd>3-1-18, Shinsuna, Koto-ku</dd>
              <dd>Tokyo 136-8585 Japan</dd>
            </dl>
            <br />
            <p><strong><u>UNOHA</u></strong></p>
            <p>如果您在我们的店铺中购买UNOHA产品，或者使用某一项由UNOHA提供的服务，ASICS总部将被视为负责收集和使用您的个人资料。ASICS总部的联系方式是：</p>
            <dl>
              <dd>ASICS Corporation</dd>
              <dd>7-1-1, Minatojima-Nakamachi, Chuo-ku</dd>
              <dd>Kobe 650-8555 Japan</dd>
            </dl>
            <br />
            <p><strong><u>欧洲、英国、非洲和中东</u></strong></p>
            <p><strong><u>ASICS 产品和服务</u></strong></p>
            <p>除ASICS全球服务以外，如您在上述区域的店铺内购买ASICS产品，或使用某一项由ASICS 欧洲公司提供的服务，ASICS 欧洲公司将会以ASICS隐私政策所载的用途处理您的个人资料，并负责该等使用。</p>
            <p>联系方式：</p>
            <dl>
              <dd>ASICS Europe B.V.</dd>
              <dd>Taurusavenue 165</dd>
              <dd>2132 LS Hoofddorp, the Netherlands</dd>
            </dl>
            <p>ASICS 欧洲有限公司的数据保护专员的联系地址请<a href="https://privacyportal-de.onetrust.com/webform/d516dd52-7883-4a41-851f-6c02e52beca9/8ede5503-8f37-4258-8436-a75da29e3f73" title="点击此处" target="_blank" rel="nofollow noopener">点击此处</a>。</p>
            <p>对于英国居民，ASICS 英国有限公司将担任第27条“ASICS Runner App, Inc.的通用数据保护条例”定义的代表。 关于联系方式（及数据保护专员的联系方式），详见下文。</p>
            <p>对于下列国家的居民，当地的ASICS公司也会被视为负责收集和使用您的个人资料的机构：</p>
            <dl>
              <dt><strong>德国: <u>ASICS Deutschland GmbH</u></strong></dt>
              <dd>Hansemannstrasse 67,</dd>
              <dd>41468 Neuss, GERMANY</dd>
            </dl>
            <dl>
              <dt><strong>法国: <u>ASICS France s.a.s.</u></strong></dt>
              <dd>1310 avenue des Platanes</dd>
              <dd>CS 55000 34974 Lattes Cedex FRANCE</dd>
            </dl>
            <dl>
              <dt><strong>意大利: <u>ASICS Italia S.r.l.</u></strong></dt>
              <dd>Via Fratelli Ceirano 3a</dd>
              <dd>Madonna dell’Olmo 12100 Cuneo ITALY</dd>
            </dl>
            <dl>
              <dt><strong>奥地利: <u>ASICS Austria GmbH</u></strong></dt>
              <dd>MoosfeldstraBe 15101</dd>
              <dd>Bergheim bei Salzburg AUSTRIA</dd>
            </dl>
            <dl>
              <dt><strong>捷克共和国: <u>ASICS Austria GmbH</u></strong></dt>
              <dd>Fashion Arena Outlet Center - j.94 Zemanhofova 440,</dd>
              <dd>10800 Praha 10 CZECH REPUBLIC</dd>
            </dl>
            <dl>
              <dt><strong>波兰: <u>ASICS Polska Sp.zo.o.</u></strong></dt>
              <dd>Bitwy Warszawskiej 1920 r.7b</dd>
              <dd>02-366 Warszawa POLAND</dd>
            </dl>
            <dl>
              <dt><strong>西班牙: <u>ASICS Iberia S.L.</u></strong></dt>
              <dd>Calle Doctor Ferrán número 25</dd>
              <dd>08034 Barcelona SPAIN</dd>
            </dl>
            <dl>
              <dt><strong>挪威: <u>ASICS Norge AS</u></strong></dt>
              <dd>Luhrtoppen 2 1470</dd>
              <dd>Lørenskog NORWAY</dd>
            </dl>
            <dl>
              <dt><strong>瑞典: <u>ASICS Sverige AB</u></strong></dt>
              <dd>Humlegardsgatan 22</dd>
              <dd>Stockholm SWEDEN</dd>
            </dl>
            <dl>
              <dt><strong>丹麦: <u>ASICS Denmark A/S</u></strong></dt>
              <dd>Robert Jacobsens Vej 66-2</dd>
              <dd>2300 København DENMARK</dd>
            </dl>
            <dl>
              <dt><strong>英国: <u>ASICS UK Limited</u></strong></dt>
              <dd>Clearwater 3, Lingley Mere Business Park,</dd>
              <dd>Lingley Green Avenue</dd>
              <dd>Warrington WA5 3UZ UNITED KINGDOM</dd>
            </dl>
            <dl>
              <dt><strong>爱尔兰: <u>ASICS UK Limited</u></strong></dt>
              <dd>Kildare Village, Unit 11 Nurney Road</dd>
              <dd>Kildare Town Co. Kildare IRELAND</dd>
            </dl>
            <dl>
              <dt><strong>葡萄牙: <u>ASICS Portugal</u></strong></dt>
              <dd>Ed.Art’s, Pq.Nações-Pas., Cantábrico, Av D.João II, Lt.1.18/D5</dd>
              <dd>1928 – 026 Lisbao PORTUGAL</dd>
            </dl>
            <!-- <dl>
              <dt><strong>俄罗斯: <u>ASICS RUSSIA</u></strong></dt>
              <dd>Olympiysky prospect, 14, 13 floor</dd>
              <dd>Moscow, 129090 RUSSIA</dd>
            </dl> -->
            <dl>
              <dt><strong>南非: <u>ASICS South Africa (Pty) Ltd.</u></strong></dt>
              <dd>Old Warehouse Building Black River Park South Fir Street Observatory</dd>
              <dd>Cape Town, SOUTH AFRICA</dd>
            </dl>
            <dl>
              <dt><strong>中东: <u>ASICS Middle East Trading LLC</u></strong></dt>
              <dd>Design District (D3) Building 5, Unit B307</dd>
              <dd>Dubai United Arab Emirates</dd>
            </dl>
            <br />
            <!-- <p><strong><u>HAGLOFS 产品和服务</u></strong></p>
            <p>如果您在我们的店铺内购买Haglöfs产品，或使用某一项由Haglöfs公司提供的服务，Haglöfs公司将会以ASICS隐私政策所载的用途处理您的个人资料，并负责该等使用。</p>
            <p>Haglöfs 联系方式：</p>
            <dl>
              <dd>Haglöfs AB,</dd>
              <dd>Henry Bergstens väg 3, Hus B SE-176 69 Järfälla, Sweden</dd>
            </dl>
            <br />
            <p>对于下列国家的居民，当地的Haglöfs公司也会被视为负责收集和使用您的个人资料的机构：</p>
            <dl>
              <dt><strong>英国: <u>Haglöfs UK</u></strong></dt>
              <dd>River Mill, Staveley Mill Yard ,</dd>
              <dd>Staveley, Cumbria, LA8 9LR, UK</dd>
            </dl>
            <dl>
              <dt><strong>瑞典: <u>Nordic Outdoor Group AB</u></strong></dt>
              <dd>Box 520, SE-77427</dd>
              <dd>Avesta, SWEDEN</dd>
            </dl>
            <dl>
              <dt><strong>挪威: <u>Haglöfs AS</u></strong></dt>
              <dd>O.H Bangsvei 51,</dd>
              <dd>1363 Høvik, Norway</dd>
            </dl>
            <dl>
              <dt><strong>丹麦: <u>Haglöfs A/S</u></strong></dt>
              <dd>Langhøjvej 1 C, True</dd>
              <dd>8381 Tilst, Denmark</dd>
            </dl>
            <dl>
              <dt><strong>德国: <u>Haglöfs Deutschland GmbH</u></strong></dt>
              <dd>Albert-Einstein-Str. 6,</dd>
              <dd>87437 Kempten, Germany</dd>
            </dl>
            <dl>
              <dt><strong>芬兰: <u>Haglöfs Oy</u></strong></dt>
              <dd>Vantaankoskentie 14,</dd>
              <dd>01670 Vantaa, Finland</dd>
            </dl>
            <br /> -->
            <p><strong><u>美国</u></strong></p>
            <p>如果您在美国的店铺内购买ASICS产品，或使用某一项由ASICS美国公司提供的服务，ASICS美国公司将被视为负责收集和使用您的个人数据。ASICS美国公司的联系方式：</p>
            <dl>
              <dd>ASICS America Corporation</dd>
              <dd>7755 Irvine Center Drive, Suite 400</dd>
              <dd>Irvine, California 92618 USA</dd>
            </dl>
            <br />
            <p><strong><u>加拿大</u></strong></p>
            <p>如果您在加拿大的店铺内购买ASICS产品，或使用某一项由ASICS加拿大公司提供的服务，ASICS加拿大公司将被视为负责收集和使用您的个人数据。ASICS加拿大公司的联系方式：</p>
            <dl>
              <dd>ASICS Canada Corporation</dd>
              <dd>5015 Spectrum Way, Unit 401</dd>
              <dd>Mississauga, ON, L4W 0E4 Canada</dd>
            </dl>
            <br />
            <p><strong><u>墨西哥</u></strong></p>
            <p>如果您在墨西哥的店铺内购买ASICS产品，或使用某一项由ASICS墨西哥公司提供的服务，ASICS墨西哥公司将被视为负责收集和使用您的个人数据。ASICS墨西哥公司的联系方式：</p>
            <dl>
              <dd>ASICS Sports Mexico, S.A. de C.V.</dd>
              <dd>Av. Prolongacion Paseo de la Reforma No. 1236</dd>
              <dd>Colonia Santa Fe, 05348, Mexico, D.F</dd>
            </dl>
            <br />
            <p><strong><u>巴西</u></strong></p>
            <p>如果您在巴西的店铺内购买ASICS产品，或使用某一项由ASICS巴西公司提供的服务，ASICS巴西公司将被视为负责收集和使用您的个人数据。ASICS巴西公司的联系方式：</p>
            <dl>
              <dd>ASICS Brasil Distribuição e Comércio de Artigos Esportivos Ltda.</dd>
              <dd>Avenida das Nações Unidas, nº 14.261, 15° andar, ALA A, Edifício W TORRE, Vila Gertrudes,</dd>
              <dd>CEP: 04794-000, São Paulo/SP. Brazil.</dd>
              <dd>E-mail: privacidade.br@asics.com</dd>
              <dd>Phone: 0800 722 7427 / 5056-8450</dd>
            </dl>
            <br />
            <p><strong><u>智利</u></strong></p>
            <p>如果您在智利的店铺内购买ASICS产品，或使用某一项由ASICS智利公司提供的服务，ASICS智利公司将被视为负责收集和使用您的个人数据。ASICS智利公司的联系方式：</p>
            <dl>
              <dd>ASICS Chile Spa</dd>
              <dd>Alcantara Nº 1303 Las Condes district, Santiago, Chile.</dd>
              <dd>E-mail: privacidade.br@asics.com</dd>
            </dl>
            <br />
            <p><strong><u>哥伦比亚</u></strong></p>
            <p>如果您在哥伦比亚的店铺内购买ASICS产品，或使用某一项由ASICS哥伦比亚公司提供的服务，ASICS哥伦比亚公司将被视为负责收集和使用您的个人数据。ASICS哥伦比亚公司的联系方式：</p>
            <dl>
              <dd>ASICS Colombia S.A.S.</dd>
              <dd>Edificio Torres Unidas II Carrera 9#113-52 Oficinas 1203/1204. Bogota, Colombia.</dd>
              <dd>E-mail: privacidade.br@asics.com</dd>
            </dl>
            <br />
            <p><strong><u>澳大利亚</u></strong></p>
            <p>如果您在澳大利亚的店铺内购买ASICS产品，或使用某一项由ASICS大洋洲公司通过asics.com或onitsukatiger.com提供的服务，ASICS大洋洲公司将被视为负责收集和使用您的个人数据。ASICS大洋洲公司的联系方式：</p>
            <dl>
              <dd>ASICS Oceania Pty Ltd (ABN 59 003 091 389)</dd>
              <dd>6 Darling Street</dd>
              <dd>Marsden Park, NSW 2765, Australia</dd>
            </dl>
            <br />
            <p><strong><u>中国大陆</u></strong></p>
            <p>如果您在中国大陆的店铺内购买ASICS产品，或使用某一项由亚瑟士（中国）商贸有限公司提供的服务，ASICS中国公司将被视为负责收集和使用您的个人数据。亚瑟士（中国）商贸有限公司的联系方式：</p>
            <dl>
              <dd>ASICS China Trading Co., Ltd.</dd>
              <dd>21F,Tower2, Shanghai Arch, No.533, Loushanguan Road,</dd>
              <dd>Changning District, Shanghai, China, 200051</dd>
            </dl>
            <br />
            <p><strong><u>香港</u></strong></p>
            <p>如果您在香港的店铺内购买ASICS产品，或使用某一项由ASICS香港公司提供的服务，ASICS香港公司将被视为负责收集和使用您的个人数据。ASICS香港公司的联系方式：</p>
            <dl>
              <dd>ASICS HongKong Limited</dd>
              <dd>Unit 1105B-6, 11/F, Exchange Tower, 33 Wang Chiu Road, </dd>
              <dd>Kwun Tong, Kowloon, Hong Kong</dd>
            </dl>
            <br />
            <p><strong><u>台湾</u></strong></p>
            <p>如果您在台湾的店铺内购买ASICS产品，或使用某一项由ASICS台湾公司提供的服务，ASICS台湾公司将被视为负责收集和使用您的个人数据。ASICS台湾公司的联系方式：</p>
            <dl>
              <dd>ASICS Taiwan Corporation</dd>
              <dd>20F., No. 156, Sec. 1, Zhongshan Rd.</dd>
              <dd>Banqiao Dist., New Taipei City 220 , Taiwan.</dd>
            </dl>
            <br />
            <p><strong><u>韩国</u></strong></p>
            <p>如果您在韩国的店铺ASICS产品，或使用某一项由ASICS韩国公司提供的服务，ASICS韩国公司将被视为负责收集和使用您的个人数据。ASICS韩国公司的联系方式：</p>
            <dl>
              <dd>ASICS Korea Corporation</dd>
              <dd>15F, Samhwa Tower, 16 Euljl-ro 5-gll. Jung-gu, Seoul 04539,</dd>
              <dd>Republic of Korea</dd>
            </dl>
            <br />
            <p><strong><u>新加坡</u></strong></p>
            <p>如果您在新加坡的店铺ASICS产品，或使用某一项由ASICS亚洲私人有限公司提供的服务，ASICS亚洲私人有限公司将被视为负责收集和使用您的个人数据。ASICS亚洲私人有限公司的联系方式：</p>
            <dl>
              <dd>ASICS Asia PTE. LTD.</dd>
              <dd>One Raffles Place #24-00</dd>
              <dd>Singapore 048616</dd>
              <dd><br /></dd>
              <dd>数据保护专员的联系方式如下：</dd>
              <dd>dataprotection-asia@asics.com</dd>
              <dd>One Raffles Place #24-00 Singapore 048616</dd>
              <dd><br /></dd>
              <dd><a href="https://privacyportal-de.onetrust.com/webform/d516dd52-7883-4a41-851f-6c02e52beca9/8ede5503-8f37-4258-8436-a75da29e3f73" title="点击此处" target="_blank" rel="nofollow noopener">点击此处</a>联系ASICS亚洲私人有限公司的数据保护专员。</dd>
            </dl>
            <br />
            <p><strong><u>泰国</u></strong></p>
            <p>如果您在泰国的店铺ASICS产品，或使用某一项由ASICS泰国有限公司提供的服务，ASICS泰国有限公司将被视为负责收集和使用您的个人数据。ASICS泰国有限公司的联系方式：</p>
            <dl>
              <dd>ASICS Thailand Co., Ltd.</dd>
              <dd>11/1 AIA Sathorn Tower 14th Floor, Unit 01 South Sathorn Road, Yannawa, Sathorn,</dd>
              <dd>Bangkok 10120 Thailand</dd>
            </dl>
            <br />
            <p><strong><u>马来西亚</u></strong></p>
            <p>如果您在马来西亚的店铺ASICS产品，或使用某一项由ASICS马来西亚有限公司提供的服务，ASICS马来西亚有限公司将被视为负责收集和使用您的个人数据。ASICS马来西亚有限公司的联系方式：</p>
            <dl>
              <dd>ASICS Malaysia Sdn. Bhd.</dd>
              <dd>Level 23B, Axiata Tower 9, Jalan Stesen Sentral 5, Kuala Lumpur Sentral</dd>
              <dd>50470 Kuala Lumpur, Malaysia</dd>
            </dl>
            <br />
            <p><strong><u>越南</u></strong></p>
            <p>如果您在越南的店铺ASICS产品，或使用某一项由ASICS越南有限公司提供的服务，ASICS越南有限公司将被视为负责收集和使用您的个人数据。ASICS越南有限公司的联系方式：</p>
            <dl>
              <dd>ASICS Vietnam LLC</dd>
              <dd>Saigon Centre, Lot L2-26-29, 67 Le Loi, Ben Nghe Ward,</dd>
              <dd>District 1, Ho Chi Minh City, Vietnam</dd>
            </dl>
            <br />
            <p><strong><u>印度尼西亚</u></strong></p>
            <p>如果您在印度尼西亚的店铺购买ASICS产品，或使用某一项由ASICS印度尼西亚有限公司提供的服务，ASICS印度尼西亚有限公司将被视为负责收集和使用您的个人数据。ASICS印度尼西亚有限公司的联系方式：</p>
            <dl>
              <dd>PT ASICS Indonesia Trading</dd>
              <dd>WTC 5 Building Level 3A</dd>
              <dd>Jl. Jendral Sudirman Kav. 29-31, RT8/RW3,</dd>
              <dd>Kelurahan Karet, Kecamatan Setiabudi,</dd>
              <dd>Jakarta Selatan 12920, DKI Jakarta</dd>
            </dl>
            <br />
            <p><strong><u>印度</u></strong></p>
            <p>如果您使用某一项由ASICS印度私人公司提供的服务，ASICS印度私人公司将被视为负责收集和使用您的个人数据。<br />
              ASICS印度私人公司的联系方式：</p>
            <dl>
              <dd>ASICS India Private Limited</dd>
              <dd>Unit No. 401, 4th Floor, Worldmark-1, Sector 65, Gurugram, Haryana 122001 India</dd>
            </dl>
          </div>
          <div class="content" v-if="activeItem==6">
            <p>LOCAL DEVIATION</p>
            <p>In addition to and deviation from the ASICS Privacy Policy, the following applies:</p>
            <p><strong><u>SPECIAL INFORMATION FOR JAPAN USERS</u></strong></p>
            <p><strong>お客様情報の共有</strong></p>
            <p>株式会社アシックス、アシックスジャパン株式会社およびアシックス・スポーツコンプレックス株式会社（以下、合わせて「当社」といいます）は、当社間およびその他のアシックスグループ会社との間において、本ポリシーの「個人情報の利用目的」に記載の利用目的達成のために、「取得する個人情報」に記載のお客様の個人情報を共同利用いたします。この場合、株式会社アシックスがお客様の個人情報の管理について責任を負います。</p>
            <p>共同利用者であるアシックスグループ会社の情報（所在地等）はこちらをご覧ください。</p>
            <p><strong>お客様の個人情報の開示等の請求について</strong></p>
            <p>当社が保有するお客様情報に関して、開示等（以下１～６）を希望される場合には、お申し出いただいた方がご本人であることを確認した上で、個人情報の保護に関する法律に従い、合理的な期間および範囲で開示等の求めに応じます。</p>
            <dl>
              <dd>1.利用目的の通知</dd>
              <dd>2.開示</dd>
            </dl>
            <div>但し、お客様が開示を求められる個人情報を特定できない場合は、開示をお断りすることがあります。</div>
            <dl>
              <dd>3.不正確な情報についての訂正、追加または削除</dd>
              <dd>4.利用停止・消去</dd>
            </dl>
            <div>但し、情報の一部または全部を利用停止または消去した場合、不本意ながらご要望にそったサービスの提供ができなくなることがありますので、ご了承ください。なお、利用停止または消去のお申し出が、法令上の要件を満たさない場合には、当社はお客様のお申し出をお断りする場合があります。</div>
            <dl>
              <dd>5.お客様情報の第三者への移転の記録（もしあれば）の開示</dd>
              <dd>6.安全管理のために講じた措置の開示</dd>
            </dl>
            <br />
            <p>上記の請求および本ポリシーに関するご質問、その他お問合せについては、こちらへご連絡ください。</p>
            <p><strong>アシックスジャパン株式会社の個人情報の取扱いについて</strong></p>
            <p>本ポリシーのほか、アシックスジャパン株式会社の個人情報の取り扱い、個人情報管理責任者、個人情報の開示請求等についてはこちらをご参照ください。</p>
            <p><strong><u>SPECIAL INFORMATION FOR U.S. USERS</u></strong></p>
            <p>In the United States personal information is collected and processed by ASICS America Corporation and/or ASICS Runner App, Inc.</p>
            <p><strong>Your California Privacy Rights</strong></p>
            <p>Californians have additional rights explained <a href="https://www.asics.com/us/en-us/california-laws.html" title="Click Here" target="_blank" rel="nofollow noopener">here</a>.</p>
            <p><strong>Your Nevada Privacy Rights</strong></p>
            <p>Although we do not “sell” “covered information” of Nevada “consumers” as those terms are defined by Chapter 603A of the Nevada Revised Statutes, you may contact us at <a href="mailto:nevadaprivacy@asics.com" title="Click Here" rel="nofollow noopener">nevadaprivacy@asics.com</a> and register an e-mail contact address for us to provide you notice in the event we should do so in the future, at which point you will have an opportunity to be verified and exercise your opt-out rights under that law.  Contact us in the same manner to update your contact email for notices.  Changing your email address elsewhere (e.g., information requests, account information, etc.) will not update your Nevada notice contact information.  It is your responsibility to keep your notice contact information current. </p>
            <p><strong><u>SPECIAL INFORMATION FOR BRAZILIAN USERS</u></strong></p>
            <p>In Brazil, personal information is collected and processed by ASICS Brasil Distribuição e Comércio de Artigos Esportivos Ltda. in accordance with ASICS Brazil Privacy Policy available at: <a href="https://www.asics.com.br/politica-de-privacidade" title="请点击此处" target="_blank" rel="nofollow noopener">https://www.asics.com.br/politica-de-privacidade</a>. In case of any doubt, please contact our Data Privacy Officer by e-mail at <a href="mailto:privacidade.br@asics.com" title="请点击此处" rel="nofollow noopener">privacidade.br@asics.com</a>, phone +55 11 5056-8450 or by <a href="https://privacyportal-de.onetrust.com/webform/d516dd52-7883-4a41-851f-6c02e52beca9/5a522e34-a29c-4671-9f38-4247fbcdbf52" title="请点击此处" target="_blank" rel="nofollow noopener">this link</a>. </p>
            <p><strong><u>SPECIAL INFORMATION FOR AUSTRALIAN USERS</u></strong></p>
            <p><strong>INTERNATIONAL TRANSFERS OF YOUR PERSONAL DATA</strong></p>
            <p>You agree that we may transfer and process any of your personal data and personal information as described in the “International Transfers of Your Personal Data” section of this Policy. We may transfer and process this data in countries including Japan and the United States of America.</p>
            <p><strong>ANONYMITY</strong></p>
            <p>We provide the option for individuals to not identify themselves, or of using a pseudonym when dealing with us, for example, if you seek general information about our products or Services. We do not provide this option in circumstances where it is impracticable to do so. <br />In some circumstances, if you choose not to provide all or some of the personal information requested by us, then we may not be able to provide you with the requested products and/or Services. </p>
            <p><strong>APPLICABLE LAW</strong></p>
            <p>You agree that all claims and disputes concerning any of your personal information collected by ASICS Oceania Pty Ltd will remain subject to the exclusive jurisdiction of the Courts of New South Wales, Australia.</p>
            <p><strong><u>SPECIAL INFORMATION FOR NEW ZEALAND USERS</u></strong></p>
            <p><strong>INTERNATIONAL TRANSFERS OF YOUR PERSONAL DATA</strong></p>
            <p>You agree that we may transfer and process any of your personal data and personal information as described in the “International Transfers of Your Personal Data” section of this Policy.</p>
            <p>In New Zealand your personal data and personal information may also be collected and processed in Australia by ASICS Oceania Pty Ltd. This may take place when you use any of our Services.</p>
            <p><strong>IF YOU CHOOSE NOT TO PROVIDE PERSONAL INFORMATION</strong></p>
            <p>In some circumstances, if you choose not to provide all or some of the personal information requested by us, then we may not be able to provide you with the requested products and/or Services.</p>
            <p><strong>APPLICABLE LAW</strong></p>
            <p>You agree that all claims and disputes concerning any of your personal information collected by ASICS Oceania Pty Ltd will remain subject to the exclusive jurisdiction of the Courts of New South Wales, Australia.</p>
            <p><strong><u>SPECIAL INFORMATION FOR CHINA MAINLAND USERS</u></strong></p>
            <p>针对中国大陆用户的特别提示</p>
            <p>In China mainland, personal information is collected and processed by ASICS (China) Trading Co.,Ltd (“ASICS”) in accordance with any applicable data protection laws and regulation including China Personal Information Protection Law. In case of any doubt, please contact by e-mail cs.acn@asics.com, phone 400-821-0893.</p>
            <p>在中国大陆，亚瑟士（中国）商贸有限公司将根据包括《个人信息保护法》在内的适用的数据保护法律和法规，收集和处理您的个人信息。如有任何疑问，请联系：邮箱cs.acn@asics.com，电话400-821-0893。</p>
            <p><strong>DATA RETENTION</strong></p>
            <p><strong>数据存储</strong></p>
            <p>ASICS retains your personal data for as long as is necessary to fulfil the purposes set out in this Policy, unless there is a mandatory retention requirement by law.<br />After the retention period has expired, we will delete or anonymize your personal data in accordance with applicable laws.</p>
            <p>亚瑟士只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存储要求。<br />在超出存储期间后，我们会根据适用法律删除或匿名化处理您的个人信息。</p>
            <p><strong>CHANGES TO THE POLICY</strong></p>
            <p><strong>政策更新</strong></p>
            <p>ASICS will obtain your consent to any material changes to this Policy if and where required by applicable data protection laws.</p>
            <p>如适用的数据保护法律有所要求，亚瑟士将会获取您对于重大变更的同意。</p>
            <p><strong>INTERNATIONAL TRANSFERS OF YOUR PERSONAL DATA</strong></p>
            <p><strong>个人信息跨境传输</strong></p>
            <p>ASICS will take necessary data management action as required by applicable laws and regulations before transferring your personal data outside China mainland.</p>
            <p>将您的个人信息传输至中国大陆区域外前，亚瑟士将根据适用法律和法规的要求采取必要的数据管理措施。</p>
            <p><strong>SEPARATE CONSENT</strong></p>
            <p><strong>单独同意</strong></p>
            <p>ASICS will seek your separate consent for the processing of sensitive personal information or any other personal information for which separate consent is required by applicable law, depending on your actual use.</p>
            <p>在处理个人敏感信息或其他任何依适用法律需要单独获取同意的情况下，亚瑟士将会根据您实际使用情况单独征求您的同意。</p>
            <p><strong><u>SPECIAL INFORMATION FOR SOUTH KOREA USERS</u></strong></p>
            <p>In addition to this Policy, in South Korea, personal information is collected and processed by ASICS Korea Corporation in accordance with ASICS Korea Privacy Policy available at <a href="https://www.asics.co.kr/service/privacy" title="请点击此处" target="_blank" rel="nofollow noopener">https://www.asics.co.kr/service/privacy</a>.</p>
            <p><strong><u>대한민국 사용자를 위한 특별 정보</u></strong></p>
            <p>본 정책 이외에도 대한민국에서는 ㈜아식스코리아가 ㈜아식스코리아의 개인정보처리방침에 따라 개인정보를 수집 및 처리하고 있으며, 해당자료는 다음 주소에서 확인 가능합니다 <a href="https://www.asics.co.kr/service/privacy" title="请点击此处" target="_blank" rel="nofollow noopener">https://asics.co.kr/service/privacy</a>.</p>
            <p><strong><u>SPECIAL INFORMATION FOR SINGAPORE USERS</u></strong></p>
            <p><strong>YOUR CONSENT</strong></p>
            <p>Please note that, by agreeing to this Policy, you are consenting to ASICS collecting, using and disclosing your personal data for all the relevant purposes set out in the “What We Do With Your Personal Data” section of this Policy.</p>
            <p><strong><u>SPECIAL INFORMATION FOR THAILAND USERS</u></strong></p>
            <p>You are entitled to (i) withdraw your consent to any use or disclosure of any personal data, (ii) object to any collection, use, processing or disclosure of any personal data, (iii) request a suspension of the use of any personal data, (iv) request an access to, or a provision, correction, updating or deletion of any personal data, and (v) make a complaint regarding any violation or non-compliance of the privacy policy by ASICS. If at any time you would like to do so, please send us your request here. In certain circumstances, including when required by applicable law, we will comply with your request. Before we are able to provide you with any information or correct any inaccuracies, we may ask you to verify your identity and/or provide other details to help us respond to your request.</p>
            <p><strong><u>SPECIAL INFORMATION FOR MALAYSIAN USERS</u></strong></p>
            <p><strong>IF YOU ARE UNDER 18 YEARS OF AGE</strong></p>
            <p>If you are under 18 years of age, please get the consent of your parent or legal guardian before you give us any personal data about yourself. Your parent or guardian should contact us here and provide us with their name, e-mail address and any other identifying information that we may request. If you are under 18 years of age, do not contact us or provide us with any personal data until after your parent or guardian has sent us an e-mail consenting to your contact and provision of such information.</p>
            <p><strong>LANGUAGE OF THIS POLICY</strong></p>
            <p>In accordance with Section 7(3) of the Malaysian Personal Data Protection Act 2010 (PDPA), this Policy is issued in both English and Bahasa Malaysia. In the event of any inconsistencies or discrepancies between the English version and the Bahasa Malaysia version, the English version shall prevail.</p>
            <p><strong><u>SPECIAL INFORMATION FOR SOUTH AFRICAN USERS</u></strong></p>
            <p>Reference to personal data or personal information in the ASICS privacy policy shall mean personal information as defined in the Protection of Personal Information Act, 2013 (“POPIA”) insofar as the processing activities and data subjects fall within the ambit of POPIA. Personal data accordingly includes the personal information of an identifiable, living, natural person and where applicable, an existing juristic person (company).</p>
            <p>Reference to data controllers in the ASICS privacy policy shall include responsible parties as defined in POPIA.</p>
            <p>Reference to data processors in the ASICS privacy policy shall include operators as defined in POPIA.</p>
            <p><strong>PERSONAL DATA WE COLLECT</strong></p>
            <p>Save for personal data that we are required or permitted by law to collect, all personal data provided by you is provided voluntarily. However, if you do not provide the personal data requested by us, or you revoke consent previously provided, we may not be able to effectively manage our relationship with you and provide products and/or the Services to you.</p>
            <p><strong>SPECIAL CATEGORIES OF PERSONAL DATA</strong></p>
            <p>Reference to special categories of personal data includes Special Personal information as defined in POPIA (i.e. religious or philosophical beliefs, race or ethnic origin, trade union membership, political persuasion, health or sex life, biometric information, and criminal behaviour to the extent that such information relates to the alleged commission by a data subject of any offence or any proceedings in respect of any offence allegedly committed by a data subject or the disposal of such proceedings.)</p>
            <p>We will only use health data you voluntarily provide us and such only with your prior consent or under your direction to do so and only for the purposes set out in this Privacy Policy. You may refuse or revoke your consent at any time, as set out below (see 'Your Rights') but should you not provide the data or revoke your consent then we may not be able to manage our relationship with you and provide products and/or the Services to you.</p>
            <p><strong>WHAT WE DO WITH YOUR INFORMATION</strong></p>
            <p>Use of information based on your consent</p>
            <p>We may process your personal data on the basis of your specific, informed and voluntary consent.</p>
            <p>We may also use the Special Personal Information referred to above (i.e. health data ) for the purposes set out in this ASICS privacy policy but we will only do so after we have received your consent thereto.</p>
            <p>You can withdraw your consent at any time but this may affect the way in which we manage our relationship with you and may have an impact on the products and Services that we can provide.</p>
            <p><strong>IF YOU ARE UNDER 18 YEARS OF AGE</strong></p>
            <p>Our online Services are not directed to children under 18 years of age. If you believe we have collected information about a child under the age of 18, please contact us (see 'Information Officer - Contact and Queries' below) so that we may take appropriate steps to delete such information.</p>
            <p>If you are under 18 years of age, please get the consent of your parent or legal guardian or another competent person before you give us any personal data about yourself. Your parent or guardian or another competent person should contact us here and provide us with their name, e-mail address and any other identifying information that we may request. ASICS needs this information in order to verify that they have provided the necessary consent. We may follow up by phone or other means in some circumstances. If you are under 18 years of age, do not contact us or provide us with any personal data until after your parent or guardian or another competent person has sent us an e-mail consenting to your contact and provision of such information.</p>
            <p><strong>INTERNATIONAL TRANSFERS OF YOUR PERSONAL DATA</strong></p>
            <p>Where required by POPIA or other applicable laws, ASICS will ensure that recipients of your personal data are subject to a binding agreement which provides an adequate level of protection for the processing of your personal data similar to that of POPIA. We will also obtain the necessary regulatory approvals where such transfers require regulatory approval in terms of applicable data protection laws.</p>
            <p><strong>DATA RETENTION</strong></p>
            <p>We may retain your personal data for a longer period than the period required to satisfy the purpose for which your personal data was collected and processed or which is necessary for our legal obligations or to defend a legal claim if such retention period is required or authorized in terms of applicable laws, is required by a contract between ASICS and you, or on the basis of your consent. ASICS may also retain personal data for historical, statistical or research purposes provided there are appropriate safeguards against the personal data being used for any other purpose.</p>
            <p><strong>YOUR RIGHTS</strong></p>
            <p>Subject to applicable laws, you have the following rights concerning your personal data: the right to request access to your personal data; the right to request the correction, destruction or deletion of your personal data; the right to object on reasonable grounds to the processing of your personal data where the processing is on the basis that it protects your legitimate interests or is on the basis that it is necessary for pursuing the legitimate interests of ASICS or a third party to whom the personal data is supplied; the right to object to the processing of your data for the purposes of direct marketing; the right not to be subject to a decision which is based solely on the basis of automated processing of your personal data; the right to submit a compliant to the Information Regulator in South Africa; and the right to institute civil proceedings.</p>
            <p>In case you may have a question or complaint about how we process your personal data, you can send an email to the ASICS company responsible for processing your personal data (an overview can be found <a href="https://www.asics.com/privacy/privacy-policy" title="请点击此处" target="_blank" rel="nofollow noopener">here</a>). Alternatively, you may consider lodging a complaint with the Information Regulator.</p>
            <p>
              The Information Regulator's contact details are as follows:<br />
              The Information Regulator (South Africa)<br />
              JD House<br />
              27 Stiemens Street<br />
              Braamfontein<br />
              Johannesburg<br />
              2001<br />
              email: <a href="mailto:inforeg@justice.gov.za" title="请点击此处" rel="nofollow noopener">inforeg@justice.gov.za</a> / <a href="mailto:complaints.IR@justice.gov.za" title="请点击此处" rel="nofollow noopener">complaints.IR@justice.gov.za</a>.
            </p>
            <p><strong>DATA PROTECTION OFFICER - CONTACT AND QUERIES</strong></p>
            <p>If you have any questions regarding the processing of your personal data or this privacy policy, please contact the ASICS Information Officer, or the ASICS company responsible for using your personal data. The details of ASICS in South Africa are as follows:</p>
            <p>Asics South Africa Proprietary Limited</p>
            <p>
              Address: Old Warehouse Building, Black River Park South, Fir Street, Observatory ERF 163099, Cape Town, Western Cape, 7925<br />
              Tel: 021 300 7710<br />
              Postal Address: Old Warehouse Building, Black River Park South, Fir Street, Observatory ERF 163099, Cape Town, Western Cape, 7925
            </p>
            <p>
              Details of Information Officer in South Africa: Nicholas Bingham<br />
              <a href="https://www.asics.com/privacy" title="请点击此处" target="_blank" rel="nofollow noopener">https://www.asics.com/privacy/</a> or use <a href="mailto:Privacy-aeb@asics.com" title="请点击此处" rel="nofollow noopener">Privacy-aeb@asics.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      siderList: [
        { name: "使用条款和条件" },
        { name: "隐私政策", url:'https://legal.asics.com/cn-cn/legal/privacy-policy' },
        { name: "联系我们" },
        { name: "COOKIE政策", url:'https://legal.asics.com/cn-cn/legal/cookie-policy' },
        { name: "关于Onitsuka Tiger" },
        { name: "负责使用个人资料的ASICS公司概述", url:'https://legal.asics.com/cn-cn/legal/overview-of-asics-companies' },
        // { name: "地区差异" }
      ],
      activeItem: 0,
      title: "使用条款和条件"
    };
  },
  created() {
    let active = this.$route.query.active;
    if (active >= 0 && active <= 6) {
      this.clickSidebar(~~active);
    }
  },
  watch: {
    $route(from) {
      this.clickSidebar(~~from.query.active);
    }
  },
  methods: {
    clickSidebar(idx) {
      if(this.siderList[idx].url){
        location.href = this.siderList[idx].url
        return;
      }
      this.activeItem = idx;
      switch (idx) {
        case 1:
          this.title = "隐私政策";
          break;
        case 2:
          this.title = "联系我们";
          break;
        case 3:
          this.title = "COOKIE政策";
          break;
        case 4:
          this.title = "关于Onitsuka Tiger";
          break;
        case 5:
          this.title = "负责使用个人资料的ASICS公司概述";
          break;
        // case 6:
        //   this.title = "地区差异";
        //   break;
        default:
          this.title = "使用条款和条件";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.privacy-policy {
  width: 110rem;
  margin: 0 auto;
  a {
    font-size: 12px; color: #7f0019; text-decoration: underline;
    &.online_chat {
      display: none; width: 300px; height: 45px; line-height: 45px; font-size: 14px; text-decoration: none; 
      text-align: center; border: 1px solid #EFEFEF; border-radius: 4px;
    }
  }
  .title {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    h1 {
      font-size: 24px;
      font-weight: 400;
      // text-transform: uppercase;
      letter-spacing: 0.1rem;
    }
  }
  .support-main {
    padding-top: 50px;
    .sidebar-column,
    .content-column {
      box-sizing: border-box;
    }
    .sidebar-column {
      width: 33%;
      padding-right: 15px;
      li {
        font-size: 1.4rem;
        font-weight: 400;
        // text-transform: uppercase;
        list-style: none;
        border-bottom: 1px solid #999;
        padding: 0 0 15px;
        margin: 0 0 20px;
        text-align: left;
        span {
          color: #999;
          cursor: pointer;
        }
        &.current span {
          color: #000;
        }
      }
    }
    .content-column {
      width: 66%;
      padding-left: 15px;
      text-align: left;
      h3 {
        font-size: 2.4rem;
      }
      .article-typography {
        font-size: 1.2rem;
        -webkit-font-smoothing: antialiased !important;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
        text-rendering: optimizeLegibility;
        font-weight: 200;
        padding-bottom: 50px;
        line-height: 2;
        p {
          color: #333;
          margin-bottom: 20px;
          word-wrap: break-word;
        }
        ul { padding-left: 2rem; }
        ul li { list-style-type: disc; line-height: 1.5; }
        dl dd { margin-left: 2rem; }
      }
      .article-typography * {
        max-width: 110rem;
        margin: 0 auto;
      }
    }
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
}
@media only screen and (max-width: 1024px) {
  .privacy-policy {
    width: auto;
    a.online_chat { display: block; }
    .support-main {
      .sidebar-column {
        padding: 0 15px;
        width: 100%;
      }
      .content-column {
        width: 100%;
        padding: 0 15px;
      }
    }
    .fl {
      float: none;
    }
    .fr {
      float: none;
    }
  }
}
</style>